import { ENV } from '@/config/env';

const MAX_RETRIES = 1;
const RETRY_DELAY = 500;

const wait = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));

export const executeReCaptcha = (retryCount = 0): Promise<string> =>
  new Promise((resolve, reject) => {
    if (typeof window === 'undefined' || !window.grecaptcha) {
      reject(new Error('reCAPTCHA is not loaded'));
      return;
    }

    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha?.execute(ENV.GOOGLE_SITE_KEY || '', {
          action: 'submit',
        });

        resolve(token || '');
      } catch (error) {
        console.error(`Failed to execute reCAPTCHA (attempt ${retryCount + 1}/${MAX_RETRIES + 1})`, error);

        if (retryCount < MAX_RETRIES) {
          try {
            await wait(RETRY_DELAY);
            const token = await executeReCaptcha(retryCount + 1);

            resolve(token);
          } catch (retryError) {
            reject(retryError);
          }
        } else {
          resolve(ENV.GTOKEN || '');
        }
      }
    });
  });
